/* eslint "jsx-a11y/label-has-associated-control": "off" */ function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import cx from "classnames";
import { twMerge } from "../../../utils";
import { Subheading } from "../Subheading";
export var FieldLabel = function(_param) /*#__PURE__*/ {
    var children = _param.children, className = _param.className, props = _objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return React.createElement("label", _extends({}, props, {
        className: twMerge(cx("block mb-3", className))
    }), /*#__PURE__*/ React.createElement(Subheading, {
        className: "text-xs text-fg-default"
    }, children));
};

//# sourceMappingURL=FieldLabel.js.map